document.addEventListener('DOMContentLoaded', () => {
  const qs = s => document.querySelector(s);
  const all = s => document.querySelectorAll(s);

  all('.colfilter-title-wrapper').forEach(el => {
    el.addEventListener('click', () => {
      el.nextElementSibling.classList.toggle('active');
      const i = el.querySelector('i');
      i.classList.toggle('bi-plus-lg');
      i.classList.toggle('bi-dash-lg');
    });
  });

  qs('.colfilter-btn-wrapper')?.addEventListener('click', () => {
    qs('.collection-filters')?.classList.add('active');
    qs('.collection-filter-bck')?.classList.add('active');
  });

  qs('.colfil-close-btn')?.addEventListener('click', () => {
    qs('.collection-filters')?.classList.remove('active');
    qs('.collection-filter-bck')?.classList.remove('active');
  });

  const cont = qs('.collection-filter-container');
  const contBck = qs('.collection-filter-container-bck');

  const closeCont = () => {
    cont?.classList.remove('active');
    contBck?.classList.remove('active');
  };

  qs('.colpage-filter-btn')?.addEventListener('click', e => {
    e.stopPropagation();
    cont?.classList.add('active');
    contBck?.classList.add('active');
  });

  qs('.colfil-close')?.addEventListener('click', e => {
    e.stopPropagation();
    closeCont();
  });

  cont?.addEventListener('click', e => e.stopPropagation());

  document.addEventListener('click', e => {
    if (cont?.classList.contains('active') && !cont.contains(e.target)) closeCont();
  });
});

/* ─── 두 번째 DOMContentLoaded 블록: URL-빌드 & 체크 토글만 책임 ─── */
document.addEventListener('DOMContentLoaded', () => {
  const $  = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));

  /* ① 필터 값 클릭 시 active 토글 + checkbox 상태 동기화 */
  $$('.filter-value').forEach(li => {
    li.addEventListener('click', e => {
      e.preventDefault();                              // a 태그 기본동작 취소
      li.classList.toggle('active');
      const cb = li.querySelector('.filter-checkbox');
      if (cb) cb.checked = li.classList.contains('active');
    });
  });

  /* ② collection 기본 경로 → “/collections/핸들” */
  const basePath = () => {
    const p = location.pathname.split('/').filter(Boolean); // ['', 'collections', 'handle', ...]
    return '/' + p.slice(0, 2).join('/');                   // '/collections/handle'
  };

  /* ③ active 된 data-tag 들을 + 로 연결해 URL 생성 */
  const buildUrl = () => {
    const tags = $$('.filter-value.active')
                  .map(li => li.dataset.tag?.trim())
                  .filter(Boolean)
                  .join('+');
    return basePath() + (tags ? '/' + tags : '') + location.search;
  };

  /* ④ VIEW RESULTS → 새 URL 로 이동 */
  $('.colfilter-btn')?.addEventListener('click', () => {
    location.href = buildUrl();
  });

  /* ⑤ CLEAR FILTERS → 태그 부분 제거 */
  $('.colfil-clear')?.addEventListener('click', () => {
    location.href = basePath() + location.search;
  });
});
